import { render } from "./TinyOmnyIcon.vue?vue&type=template&id=916af39e"
import script from "./TinyOmnyIcon.vue?vue&type=script&lang=js"
export * from "./TinyOmnyIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__